module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "dedi_1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("To Jeanne Rose Fontana Lower (Mills College ’39),"), _c('br'), _vm._v("and to Ray Lower, "), _c('em', [_vm._v("in memoriam")]), _vm._v(", for their generous"), _c('br'), _vm._v(" support through the years, access to their wonderful"), _c('br'), _vm._v(" library and knowledge of all things Sinclair, and"), _c('br'), _vm._v(" for introducing me to Donal Sean.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f0b98c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofStorms_dedi_1.vue
// module id = 72
// module chunks = 0